import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  PageSubTitle,
  Loading,
  LinkBack
} from 'components/common/Elements/Elements';
import { LineHS } from 'components/common/charts/charts';
import DimensionsChart from './DimensionsChart/DimensionsChart';
import DimensionTable from './DimensionTable/DimensionTable';

import { postRequest } from 'utils/requests';
import useWindowSize from 'hooks/useWindowSize';

import classes from './SatisfactionHealth.module.scss';

const SatisfactionHealth = ({ customerId }) => {
  const [healthScoreData, setHealthScoreData] = useState({});
  const [loader, setLoader] = useState(true);
  const [show, setShow] = useState(true);
  const [oldSize, setOldSize] = useState(0);
  const size = useWindowSize();

  const additional = healthScoreData.trendLine
    ? healthScoreData.trendLine[healthScoreData.trendLine.length - 1]
        .healthScore
    : 0;

  useEffect(() => {
    let cancelled = false;
    postRequest('/customer/satisfaction/healthscore', {
      customerId: customerId
    })
      .then(res => {
        if (!cancelled) {
          setHealthScoreData(res.body);
          setLoader(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          console.log(err);
          setLoader(false);
        }
      });
    return () => (cancelled = true);
  }, [customerId]);

  useEffect(() => {
    let timer = null;
    if (oldSize > size.width || (size.width >= 1441 && oldSize < 1441)) {
      setShow(false);
      setOldSize(size.width);
      timer = setTimeout(() => setShow(true), 500);
    } else setOldSize(size.width);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [size.width]);

  if (loader) {
    return <Loading />;
  }

  return (
    <>
      <div className={classes.header}>
        <PageSubTitle title="Health Score:" additional={additional} />
        <LinkBack text="Satisfaction" />
      </div>
      {show ? (
        <>
          <div className={classes.charts}>
            <DimensionsChart
              chartData={healthScoreData.dimensions}
              additional={additional}
            />
            <LineHS chartData={healthScoreData.trendLine} type="trend" />
          </div>
          <DimensionTable tableData={healthScoreData.dimensions} />
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

SatisfactionHealth.propTypes = {
  customerId: PropTypes.string
};

export default memo(SatisfactionHealth);
